import { Routes } from '@angular/router';
import { PageResolver } from './services/resolver.service';
import { StartRendererComponent } from './renderer/start/start-renderer.component';
import { HofRendererComponent } from './renderer/hof/hof-renderer.component';
import { ApartmentRendererComponent } from './renderer/apartment/apartment-renderer.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/de/start',
        pathMatch: 'full',
    },
    {
        path: 'hof',
        redirectTo: '/de/hof/home',
        pathMatch: 'full',
    },
    {
        path: 'apartment',
        redirectTo: '/de/apartment/home',
        pathMatch: 'full',
    },
    {
        path: ':languageCode/apartment',
        redirectTo: (route) => {
            const languageCode = route.params['languageCode'];
            if (languageCode === 'de' || languageCode === 'en') {
                return `${route.params['languageCode']}/apartment/home`;
            }
            return `de/apartment/home`;
        },
        pathMatch: 'full',
    },
    {
        path: ':languageCode/hof',
        redirectTo: (route) => {
            const languageCode = route.params['languageCode'];
            if (languageCode === 'de' || languageCode === 'en') {
                return `${route.params['languageCode']}/hof/home`;
            }
            return `de/hof/home`;
        },
        pathMatch: 'full',
    },
    {
        path: ':languageCode/:slug',
        redirectTo: (route) => {
            const languageCode = route.params['languageCode'];
            if (languageCode !== 'de' && languageCode !== 'en') {
                return `de/${route.params['languageCode']}/${route.params['slug']}`;
            }
            return `${route.params['languageCode']}/${route.params['slug']}`;
        },
        pathMatch: 'full',
    },
    {
        path: ':languageCode/:slug',
        component: StartRendererComponent,
        resolve: {
            page: PageResolver,
        },
    },
    {
        path: ':languageCode/apartment/:slug',
        component: ApartmentRendererComponent,
        resolve: {
            page: PageResolver,
        },
    },
    {
        path: ':languageCode/hof/:slug',
        component: HofRendererComponent,
        resolve: {
            page: PageResolver,
        },
    },
    {
        path: ':languageCode/hof/:slug/:productSlug',
        component: HofRendererComponent,
        resolve: {
            page: PageResolver,
        },
    },
    {
        path: ':languageCode',
        redirectTo: (route) => {
            const languageCode = route.params['languageCode'];
            if (languageCode === 'de' || languageCode === 'en') {
                return `${route.params['languageCode']}/start`;
            }
            return `de/start`;
        },
        pathMatch: 'full',
    },
    {
        path: '**',
        redirectTo: '/de/start',
    },
];
